import type { CardDef, Outcome } from '../types.js';

/**
 * Card-specific effect overlays for the Book 1 expansion cards. Anything not listed keeps the
 * generic per-type overlay chosen by the hero or template outcome.
 */
export const CARD_OVERLAYS: Record<string, string> = {
  twist_oath_skipped: 'overlay_oath',
  rule_chapter_title: 'overlay_rule_break',
  chaos_ink_tide: 'overlay_ink_tide',
  keep_margin_ribbon: 'overlay_keepsake',
  twist_jury_favor: 'overlay_verdict',
  rule_footnote: 'overlay_footnote_fight',
  chaos_wax_melt: 'overlay_wax_melt',
  counter_objection: 'overlay_objection',
  keep_tribunal_favor: 'overlay_verdict',
  twist_verdict_flip: 'overlay_verdict',
  chaos_sidebar_storm: 'overlay_storm',
  rule_cross_out: 'overlay_rule_break',
  twist_scar_witness: 'overlay_scar_witness',
  keep_crown_wick: 'overlay_keepsake',
};

/** Chapters where the narrator has run out of patience and gets the newer faces. */
const LATE_CHAPTERS = new Set(['ch2_inktide', 'ch3_wax']);

const GENERIC = /^overlay_(twist|chaos|counter|nope|keepsake|rule_break|rule_breaker)$/;

export function enrichVisual(
  outcome: Outcome,
  card: CardDef,
  stateKey: string,
  chapterId?: string,
): Outcome {
  const visual = outcome.visual;
  if (!visual) return outcome;
  let overlayIds = visual.overlayIds;
  const specific = CARD_OVERLAYS[card.id];
  if (specific && !overlayIds?.includes(specific)) {
    overlayIds = [specific, ...(overlayIds ?? []).filter((id) => !GENERIC.test(id))];
  }
  let narratorExpression = visual.narratorExpression;
  if (stateKey === 'dread_high' && (narratorExpression === 'panicked' || narratorExpression === 'flustered')) {
    narratorExpression = 'defeated';
  } else if (
    chapterId &&
    LATE_CHAPTERS.has(chapterId) &&
    narratorExpression === 'flustered' &&
    (card.type === 'chaos' || card.type === 'rule_breaker')
  ) {
    narratorExpression = 'exasperated';
  }
  if (overlayIds === visual.overlayIds && narratorExpression === visual.narratorExpression) return outcome;
  return { ...outcome, visual: { ...visual, overlayIds, narratorExpression } };
}
